<div class="ml-3 flex h-full max-h-[78vh] flex-1 flex-col gap-4 rounded-lg bg-gray-5 p-5 shadow-md">
  <mat-tab-group
    mat-stretch-tabs="false"
    mat-align-tabs="start"
    class="h-full"
  >
    <mat-tab [label]="'Профіль'">
      <chat-user-profile
        [member]="member()"
        [memberProfileComments]="chatState.memberComments()"
        [memberContracts]="member().contracts"
      ></chat-user-profile>
    </mat-tab>
    <mat-tab [label]="'Медична історія'">
      <chat-guarantees-list [member]="member()"></chat-guarantees-list>
    </mat-tab>
  </mat-tab-group>
</div>
